module.exports = __webpack_public_path__ + "portal-static/img/respone.fded0cf9.gif";